<div class="notifications-container">
	<div class="notifications-header">
		<h3 class="title">Notifications</h3>

		<button
			mat-mini-fab
			matTooltip="Mark all as read"
			color="primary"
			aria-label="Mark all as read"
			class="mark-all-read"
			(click)="markAllAsRead()"
		>
			<mat-icon>done</mat-icon>
		</button>
	</div>
	<h5>Today</h5>
	<div
		*ngFor="let notification of todaysNotifications; let i = index"
		class="today-notification"
		[ngClass]="{ first: i === 0 }"
	>
		<app-notification-tile
			[notification]="notification"
			(staffNotificationClicked)="onStaffNotificationClicked()"
		></app-notification-tile>
	</div>

	<h5>Previous</h5>
	<div
		*ngFor="let notification of previousNotifications; let i = index"
		class="previous-notification"
		[ngClass]="{ first: i === 0 }"
	>
		<app-notification-tile
			[notification]="notification"
			(staffNotificationClicked)="onStaffNotificationClicked()"
		></app-notification-tile>
	</div>
</div>
